import React from 'react';
import { createUseStyles, clsx, negative } from '@pushpay/styles';
import { useMediaBreakpoint, useResponsiveProp } from '@pushpay/theming';
import { alignVMap } from './alignment';
import { ColumnsProvider } from './columns-context';
const useStyles = createUseStyles(theme => ({
  root: ({
    space,
    alignItemsV
  }) => ({
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 1,
    width: '100%',
    marginLeft: negative(theme.SPACING[space]),
    alignItems: alignVMap[alignItemsV]
  }),
  stack: ({
    space
  }) => ({
    flexDirection: 'column',
    '&:before': {
      content: '""',
      display: 'block',
      marginTop: negative(theme.SPACING[space])
    }
  })
}));
export const Columns = ({
  classes: classesProp,
  className: classNameProp,
  stackWhen = 'TABLET_AND_BELOW',
  space: spaceProp = 'MEDIUM',
  alignItemsV: alignItemsVProp = 'stretch',
  children,
  ...rest
}) => {
  const space = useResponsiveProp(spaceProp);
  const alignItemsV = useResponsiveProp(alignItemsVProp);
  const stack = useMediaBreakpoint(stackWhen);
  const classes = useStyles(classesProp, {
    space,
    alignItemsV
  });
  const className = clsx(classNameProp, classes.root, stack && classes.stack);
  return /*#__PURE__*/React.createElement(ColumnsProvider, {
    stack: stack,
    space: space
  }, /*#__PURE__*/React.createElement("div", Object.assign({
    className: className
  }, rest), children));
};